import { EditCodeProjectFormActions } from 'src/codeDelivery/components/EditCodeProjectForm';
import actionCreator, { Actions } from '@utils/actionCreator';
import {
  ControlReposV1Service,
  WorkspaceIdV1,
  Cd4peApiError,
  handleApiRequest,
  UpdateControlRepoRequestV1,
  ControlRepoResponseV1,
  isInternalError,
  isCd4peApiError,
} from '@utils/api/cd4pe';
import { VcsActions } from '@utils/api/cd4pe/vcs/actions';
import { Dispatch } from 'react';
import * as at from './actionTypes';

export const editControlRepoActions = {
  editControlRepoStart: () => actionCreator(at.EDIT_CONTROL_REPO_START),
  editControlRepoComplete: (payload: ControlRepoResponseV1) =>
    actionCreator(at.EDIT_CONTROL_REPO_COMPLETE, payload),
  editControlRepoError: (error: Cd4peApiError) =>
    actionCreator(at.EDIT_CONTROL_REPO_ERROR, error),
  editControlRepoWebhookError: (error: Cd4peApiError) =>
    actionCreator(at.EDIT_CONTROL_REPO_WEBHOOK_ERROR, error),
};

export type EditControlRepoActions =
  | Actions<typeof editControlRepoActions>
  | VcsActions
  | EditCodeProjectFormActions;

export interface EditControlRepoPayload {
  workspaceId: WorkspaceIdV1;
  controlRepoName: string;
  requestBody: UpdateControlRepoRequestV1;
}

export const editControlRepo = async (
  dispatch: Dispatch<EditControlRepoActions>,
  repoPayload: EditControlRepoPayload,
) => {
  const editControlRepoCall = async (payload: EditControlRepoPayload) => {
    const repoResponse = await handleApiRequest(
      ControlReposV1Service.updateControlRepoV1(payload),
    );

    if (isInternalError(repoResponse) && repoResponse.body.code === 'VCS') {
      dispatch(
        editControlRepoActions.editControlRepoWebhookError(repoResponse),
      );
      return;
    }

    if (isCd4peApiError(repoResponse)) {
      dispatch(editControlRepoActions.editControlRepoError(repoResponse));
      return;
    }

    dispatch(editControlRepoActions.editControlRepoComplete(repoResponse));
  };

  await editControlRepoCall(repoPayload);
};
